import { render, staticRenderFns } from "./ProductCardPage.vue?vue&type=template&id=1804e8b5&"
import script from "./ProductCardPage.vue?vue&type=script&lang=ts&"
export * from "./ProductCardPage.vue?vue&type=script&lang=ts&"
import style0 from "./ProductCardPage.vue?vue&type=style&index=0&id=1804e8b5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports